export const siteMeta = {
  name: '黑料反差',
  latinName: 'CONTRAST DOSSIER',
  issue: '第 128 期',
  dateLabel: '2026 年 9 月 10 日 星期四',
  slogan: '把光环翻过来，看看背面写的是什么',
  editor: '编辑组 · 反差观察室',
};

export const tickerItems = [
  '主编导语：本期聚焦「温柔人设」与「片场真实状态」之间的落差',
  '快讯 · 某头部主播连播十二小时后关闭打赏，前后表态被指不一致',
  '快讯 · 短剧演员采访金句与片场花絮形成明显反差，话题热度上升',
  '榜单更新 · 明星身份区本周热度第一名换人',
  '快讯 · 综艺嘉宾「接地气」形象与随行团队规模被对比讨论',
  '编辑部提醒 · 所有内容为公开信息整理，请理性阅读',
  '专题上线 · 网红区新增「滤镜前后」对照档案合集',
];

export const navItems = [
  { label: '封面', href: '#cover' },
  { label: '身份分区', href: '#zones' },
  { label: '快讯流', href: '#flash' },
  { label: '封面人物', href: '#feature' },
  { label: '反差热度榜', href: '#heat' },
  { label: '档案架', href: '#dossier' },
  { label: '编辑手记', href: '#editor' },
  { label: '专题入口', href: '#topics' },
];

export const identityZones = [
  {
    key: 'star',
    label: '黑料反差明星',
    latin: 'CELEBRITY',
    count: 486,
    desc: '银幕形象与私下谈吐的落差记录，从采访现场到片场花絮逐条归档。',
    keywords: ['采访翻车', '人设崩塌', '片场花絮'],
    icon: 'ri-vip-crown-2-line',
    tone: 'primary',
  },
  {
    key: 'influencer',
    label: '黑料反差网红',
    latin: 'INFLUENCER',
    count: 372,
    desc: '滤镜前后、文案与实物、带货承诺与实际到货之间的对照速览。',
    keywords: ['滤镜前后', '带货对比', '内容搬运'],
    icon: 'ri-camera-lens-line',
    tone: 'accent',
  },
  {
    key: 'streamer',
    label: '黑料反差主播',
    latin: 'STREAMER',
    count: 295,
    desc: '直播间的即时发言与下播后的公开表态，被按时间线逐条对齐。',
    keywords: ['下播变脸', '打赏争议', '连麦现场'],
    icon: 'ri-live-line',
    tone: 'secondary',
  },
  {
    key: 'public',
    label: '黑料反差公众人物',
    latin: 'PUBLIC FIGURE',
    count: 208,
    desc: '公开场合的立场表达与过往言论的一致性核对，只看公开可查信息。',
    keywords: ['场合发言', '旧帖回溯', '立场核对'],
    icon: 'ri-government-line',
    tone: 'foreground',
  },
];

export const flashTimeline = [
  {
    id: 'f1',
    time: '09:40',
    tag: '明星',
    tagTone: 'primary',
    title: '「温柔前辈」采访片段流出，与片场花絮对照后话题升温',
    summary: '同一档期的两段公开影像被并排放置，评论区开始讨论人设与真实状态之间的距离。',
    heat: 92,
  },
  {
    id: 'f2',
    time: '08:55',
    tag: '主播',
    tagTone: 'secondary',
    title: '连播十二小时后关闭打赏，前后两次表态被指不一致',
    summary: '粉丝整理出前后两场直播的发言时间点，形成一条清晰的反差时间线。',
    heat: 88,
  },
  {
    id: 'f3',
    time: '08:10',
    tag: '网红',
    tagTone: 'accent',
    title: '同款单品实测视频发布，实物与详情页描述出现偏差',
    summary: '对比视频上线两小时后进入榜单前列，相关话题讨论量持续走高。',
    heat: 81,
  },
  {
    id: 'f4',
    time: '07:32',
    tag: '公众人物',
    tagTone: 'foreground',
    title: '三年前旧帖被重新整理，与近期公开访谈表述并列呈现',
    summary: '存档帖与最新访谈被放在同一页面，读者可自行核对时间与语境。',
    heat: 74,
  },
  {
    id: 'f5',
    time: '06:48',
    tag: '明星',
    tagTone: 'primary',
    title: '剧组宣传期采访更新，宣传口径与路透画面语境不同',
    summary: '宣传期物料与现场路人视角被前后对照，讨论集中在语境差异。',
    heat: 69,
  },
  {
    id: 'f6',
    time: '00:20',
    tag: '专题',
    tagTone: 'accent',
    title: '「滤镜前后」档案合集完成扩容，新增十二条对照记录',
    summary: '网红区专题完成本轮更新，档案架同步上架新的对照条目。',
    heat: 61,
  },
];

export const coverFeature = {
  name: '林砚舟',
  role: '黑料反差明星 · 本期封面人物',
  headline: '他把「慢热」演了十年，镜头外的十分钟说明了一切',
  dek: '从采访现场的沉默，到后台花絮里的高频发言，同一位演员在两种场合留下完全不同的语速。本期我们把公开影像按时间排开，只呈现可查证的部分。',
  beforeLabel: '公开形象',
  beforeText: '采访中习惯沉默、用短句作答，被形容为「慢热型前辈」。',
  afterLabel: '现场记录',
  afterText: '后台花絮连续表达近十分钟，语速与措辞明显不同。',
  points: [
    '两条素材均为公开渠道发布，时间相差不到两周',
    '编辑部仅做时间线整理，不下结论',
    '相关档案已归档至「明星」分区第 41 号条目',
  ],
  image:
    'https://readdy.ai/api/search-image?query=Stylized%20editorial%20magazine%20feature%20image%2C%20abstract%20broken%20porcelain%20mask%20fragments%20scattered%20on%20warm%20cream%20paper%20with%20crimson%20fabric%20and%20gold%20leaf%20accents%2C%20dramatic%20side%20lighting%2C%20conceptual%20contrast%20and%20duality%20theme%2C%20artistic%20still%20life%2C%20high%20detail%2C%20no%20text%2C%20no%20people%2C%20refined%20print%20magazine%20aesthetic&width=1200&height=800&seq=cover-feature-0910&orientation=landscape',
};

export const heatRanking = [
  { rank: 1, name: '林砚舟', role: '明星', topic: '采访与花絮语速反差', heat: 96, delta: 12 },
  { rank: 2, name: '苏叶舟', role: '主播', topic: '打赏表态前后不一致', heat: 91, delta: 8 },
  { rank: 3, name: '慢半拍工作室', role: '网红', topic: '实测与详情页偏差', heat: 87, delta: -3 },
  { rank: 4, name: '陈默言', role: '明星', topic: '宣传口径与路透语境', heat: 83, delta: 5 },
  { rank: 5, name: '南屿', role: '网红', topic: '滤镜前后对照更新', heat: 79, delta: 15 },
  { rank: 6, name: '顾清和', role: '公众人物', topic: '旧帖与近期访谈并列', heat: 74, delta: -6 },
  { rank: 7, name: '夜航电台', role: '主播', topic: '下播后公开表态', heat: 70, delta: 4 },
  { rank: 8, name: '白鹭剧场', role: '网红', topic: '内容来源标注争议', heat: 66, delta: 9 },
];

export const dossiers = [
  {
    id: 'd41',
    code: 'STAR-041',
    name: '林砚舟',
    role: '明星',
    before: '「慢热、话少、不擅长采访」',
    after: '后台花絮连续表达近十分钟',
    date: '09-08',
    reads: 41200,
    tagTone: 'primary',
  },
  {
    id: 'd78',
    code: 'LIVE-078',
    name: '苏叶舟',
    role: '主播',
    before: '「打赏全部转做公益」',
    after: '两场直播表态口径不同',
    date: '09-07',
    reads: 35800,
    tagTone: 'secondary',
  },
  {
    id: 'd23',
    code: 'NET-023',
    name: '慢半拍工作室',
    role: '网红',
    before: '详情页描述「同源同厂」',
    after: '实测视频出现明显偏差',
    date: '09-07',
    reads: 29300,
    tagTone: 'accent',
  },
  {
    id: 'd52',
    code: 'PUB-052',
    name: '顾清和',
    role: '公众人物',
    before: '近期访谈强调「一贯立场」',
    after: '三年前旧帖表述不同',
    date: '09-06',
    reads: 26400,
    tagTone: 'foreground',
  },
  {
    id: 'd19',
    code: 'NET-019',
    name: '南屿',
    role: '网红',
    before: '内容主打「无滤镜实拍」',
    after: '同场景对比图差异明显',
    date: '09-05',
    reads: 22100,
    tagTone: 'accent',
  },
  {
    id: 'd63',
    code: 'LIVE-063',
    name: '夜航电台',
    role: '主播',
    before: '连线时表示「从不打广告」',
    after: '往期回放出现口播片段',
    date: '09-04',
    reads: 18700,
    tagTone: 'secondary',
  },
];

export const editorNotes = [
  {
    id: 'e1',
    kicker: '主编导语',
    title: '反差不是结论，而是一个更完整的观察角度',
    excerpt:
      '我们把公开影像与公开发言按时间排开，让读者看到同一人在不同场合的样子。这既不是定罪，也不是洗白，只是把散落的信息放回它原本的位置。',
    author: '编辑组',
    date: '09-10',
    readTime: '4 分钟',
  },
  {
    id: 'e2',
    kicker: '栏目说明',
    title: '为什么我们只使用公开渠道的信息',
    excerpt:
      '所有条目都标注来源类型与时间点。没有来源的说法不会进入档案架，这也是我们与普通爆料帖最大的区别。',
    author: '反差观察室',
    date: '09-06',
    readTime: '3 分钟',
  },
  {
    id: 'e3',
    kicker: '阅读提醒',
    title: '面对反差内容时，请保持你的判断力',
    excerpt:
      '同一个镜头可以被剪成两种情绪，同一句话也可以有两种语气。我们提供的是材料，判断始终留给读者。',
    author: '情绪编辑部',
    date: '09-02',
    readTime: '5 分钟',
  },
];

export const topicEntrances = [
  {
    label: '黑料反差明星',
    desc: '采访现场 · 片场花絮 · 宣传口径',
    count: 486,
    items: ['「慢热」与实际语速', '宣传期口径差异', '路透与成片语境'],
  },
  {
    label: '黑料反差网红',
    desc: '滤镜前后 · 带货对比 · 内容来源',
    count: 372,
    items: ['滤镜前后对照', '实测与详情页', '文案搬运记录'],
  },
  {
    label: '黑料反差主播',
    desc: '直播间发言 · 打赏表态 · 连麦现场',
    count: 295,
    items: ['下播后表态', '打赏去向核对', '连麦现场回放'],
  },
  {
    label: '黑料反差公众人物',
    desc: '公开场合 · 旧帖回溯 · 立场核对',
    count: 208,
    items: ['场合发言整理', '旧帖时间线', '立场一致性核对'],
  },
];

export const siteStats = [
  { label: '已归档条目', value: '1,361' },
  { label: '本周新增', value: '84' },
  { label: '热度榜周期', value: '每 6 小时' },
  { label: '档案来源', value: '公开渠道' },
];

export const footerColumns = [
  {
    title: '身份分区',
    links: ['黑料反差明星', '黑料反差网红', '黑料反差主播', '黑料反差公众人物'],
  },
  {
    title: '内容栏目',
    links: ['封面人物', '快讯时间线', '反差热度榜', '档案架', '编辑手记'],
  },
  {
    title: '关于本站',
    links: ['内容来源说明', '阅读提醒', '纠错与反馈', '编辑部联系方式'],
  },
];